module.exports = __webpack_public_path__ + "7df45ef30125931e6e4e83374a868f2e.png";